import { Box, useMediaQuery, useTheme } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

export default function FormContainer({ children }: Props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                width: '100%',
                boxSizing: 'border-box',
                backgroundColor: theme.palette.neutral.white,
                borderRadius: '8px',
                padding: isMobile ? '16px' : '32px',
                display: 'flex',
                gap: isMobile ? '16px' : '32px',
                alignItems: 'flex-start',
                borderTop: isMobile
                    ? `12px solid ${theme.palette.primary.P_450}`
                    : `16px solid ${theme.palette.primary.P_450}`,
            }}
        >
            {children}
        </Box>
    );
}
